const KEYWORD_PATTERN = /\b(hazards?|obstacles?|actions?|outcomes?|interruptions?)\b/gi;

function classFor(word) {
  const lower = word.toLowerCase();
  if (lower.startsWith('hazard')) return 'game-hazard';
  if (lower.startsWith('obstacle')) return 'game-obstacle';
  if (lower.startsWith('outcome')) return 'game-outcome';
  return 'game-action'; // action(s) and interruption(s)
}

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Wraps the first mention of each keyword type in a colored span, matching the
// first-per-paragraph density used throughout the guide prose. Input is escaped
// first, so it is safe to render the result with v-html.
export default function colorizeKeywords(text) {
  if (text === null || text === undefined || text === '') { return ''; }

  const seen = new Set();

  return escapeHtml(String(text)).replace(KEYWORD_PATTERN, (match) => {
    const className = classFor(match);
    if (seen.has(className)) { return match; }
    seen.add(className);
    return `<span class="${className}">${match}</span>`;
  });
}
